// extracted by mini-css-extract-plugin
export default {"content":"bulk_select_item-module___content___fbfe24cc"};